var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-100 text-gray-800 min-h-screen",attrs:{"id":"app"}},[_c('router-view'),_c('portal-target',{attrs:{"name":"modals"}}),_c('portal-target',{attrs:{"name":"fixed"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }